module.exports = __webpack_public_path__ + "img/helplogoBg01.f3504773.png";